<button mat-button [matMenuTriggerFor]="menu">
  <mat-icon class="menu-button">menu</mat-icon>
</button>
<mat-menu #menu="matMenu" class="menu">
  <button mat-menu-item
    (click)="toCurrentHome()">
    <mat-icon class="item-icon">home</mat-icon>
    <h6 i18n class="menu-item">Home/My Trip</h6>
  </button>
  @if (!isAdmin) {
    <button mat-menu-item
      (click)="toProfile()">
      <mat-icon class="item-icon">person</mat-icon>
      <h6 i18n class="menu-item">Profile</h6>
    </button>
  }
  @if (!isAdmin) {
    <button mat-menu-item
      (click)="toRecords()">
      <mat-icon class="item-icon">folder</mat-icon>
      <h6 i18n class="menu-item">Records</h6>
    </button>
  }
  @if (!isAdmin) {
    <button mat-menu-item
      (click)="toResources()">
      <mat-icon class="item-icon">description</mat-icon>
      <h6 i18n class="menu-item">Resources</h6>
    </button>
  }
  @if (!isAdmin) {
    <button mat-menu-item
      (click)="toFisheryNotices()">
      <mat-icon class="item-icon">notifications</mat-icon>
      <h6 i18n class="menu-item">Fishery Notices</h6>
    </button>
  }
  <button mat-menu-item
    (click)="toHelp()">
    <mat-icon class="item-icon">help_outline</mat-icon>
    <h6 i18n class="menu-item">Help</h6>
  </button>
  <button mat-menu-item
    (click)="logout()">
    <mat-icon class="item-icon">logout</mat-icon>
    <h6 i18n class="menu-item">Logout</h6>
  </button>
  @if (showAdminPanel) {
    <button mat-menu-item
      (click)="toAdminPage()">
      <mat-icon class="item-icon">admin_panel_settings</mat-icon>
      <h6 class="menu-item">Admin</h6>
    </button>
  }

  <!--button mat-menu-item
  (click)="toDevPage()">
  <mat-icon class="item-icon">code</mat-icon>
  <h6 i18n class="menu-item">Dev Page</h6>
</button-->

</mat-menu>
